<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="spreadsheetDashboardNotificationCard"
  [notificationIcon]="'svg_excel'"
>
  <div notification-action-button>
    <app-print-action-buttons
      (downloadSpreadsheetButtonClickedEvent)="downloadSpreadsheetButtonClickedHandler()"
      [downloadSpreadsheetFlag]="true"
      class="floating-action-buttons"
    ></app-print-action-buttons>
  </div>
</app-job-notification-card>
